module.exports = __webpack_public_path__ + "img/img_61284_0_10.aac598a6.png";